import types from "../actionTypes";

export default (
  state = {
    applicants: [],
    filteredApplicants: [],
    currentPage: 1,
    pageSize: 20,
    totalRows: 0,
    caseStatusCurrentPage: 1,
    caseStatusPageSize: 20,
    caseStatusTotalRows: 0,
    caseStatus: [],
    caseStatusModified: [],
    caseStatusDetailsByEIN: [],
    selectedCaseDetail: [],
    isSelectedCase: false
  },
  action
) => {
  switch (action.type) {
    case types.SET_EMPLOYEE_BY_MANAGER:
      return Object.assign({}, state, {
        applicants: action.applicants,
      });
    case types.SET_CASE_STATUS:
      return Object.assign({}, state, {
        caseStatus: action.caseStatus,
      });
    case types.SET_CASE_STATUS_MODIFIED:
      return Object.assign({}, state, {
        caseStatusModified: action.caseStatusModified,
      });
    case types.SET_FILTERED_EMPLOYEE_BY_MANAGER:
      return Object.assign({}, state, {
        filteredApplicants: action.filteredApplicants,
      });
    case types.SET_ERS_CASE_DETAIL_BY_EIN:
      return Object.assign({}, state, {
        caseStatusDetailsByEIN: action.caseStatusDetails,
      });
    case types.SET_ERS_TOTAL_ROWS:
      return Object.assign({}, state, { totalRows: action.totalRows });
    case types.SET_ERS_CURRENT_PAGE:
      return Object.assign({}, state, { currentPage: action.currentPage });
    case types.SET_ERS_PAGE_SIZE:
      return Object.assign({}, state, { pageSize: action.pageSize });
    case types.SET_CASESTATUS_TOTAL_ROWS:
      return Object.assign({}, state, {
        caseStatusTotalRows: action.caseStatusTotalRows,
      });
    case types.SET_CASESTATUS_CURRENT_PAGE:
      return Object.assign({}, state, {
        caseStatusCurrentPage: action.caseStatusCurrentPage,
      });
    case types.SET_CASESTATUS_PAGE_SIZE:
      return Object.assign({}, state, {
        caseStatusPageSize: action.caseStatusPageSize,
      });
    case types.SET_SELECTED_CASE_DETAIL:
      return Object.assign({}, state, {
        selectedCaseDetail: action.selectedCaseDetail,
      });
    case types.SET_IS_SELECTED_CASE:
      return Object.assign({}, state, {
        isSelectedCase: action.isSelectedCase,
      });
    default:
      return state;
  }
};
